import React from "react";
import clsx from "clsx/lite";

const SkeletonCards = ({ numOfRows = 2, itemsPerRow = 3 }) => (
	<div role="status" className="w-full animate-pulse">
		<p className="self-end my-auto text-secondary h-32"></p>
		<div className={clsx(
			"flex items-baseline mt-4 gap-3 w-full overflow-hidden",
			numOfRows === 1 ? "" : "flex-wrap")}>
			{Array.from({ length: numOfRows * itemsPerRow }).map((_, index) => (
				<div
					key={index}
					className={clsx("bg-gray-100 h-72 dark:bg-gray-200",
						itemsPerRow === 3 ?
							"w-[calc(50%-10px)] lg:w-[calc(33%-10px)]" :
							"w-[calc(50%-10px)] lg:w-[calc(25%-15px)]",
						numOfRows === 1 && "min-w-72")}
				/>
			))}
		</div>
		<span className="sr-only">Loading...</span>
	</div>
);
export default SkeletonCards;